import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: space-between;
  min-height: 100vh;
  width: 100%;
  color: var(--primary);
  background-color: var(--secondary);

  @media (max-width: 600px) {
  }
  @media (max-width: 768px) {
  }
  @media (max-width: 992px) {
  }
  @media (max-width: 1200px) {
  }
`;

export const Search = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  margin-top: -2.5rem;
  position: relative;
  width: 100%;
  gap: 2rem;
`;

export const IconBox = styled.div`
  margin: 0rem 1rem;
  padding-top: 1rem;
  img{
    width: ${(props) => props.width ? css`${props.width}rem` : css`10rem`};
  }



`;

export const ListContent = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items:center;
  justify-content: center;
  width: 100%;
  gap: 1rem;
  /* margin: 0; */
  /* padding: 0; */
  /* border-radius: 1rem; */
  @media (max-width: 940px) {
  flex-direction: column;
}
`;

export const ListItem = styled.div`
  display: flex;
  flex-direction:row;
  align-items:center;
  box-shadow: 0.3rem 0.3rem 0.3rem var(--darkBlue);
  /* height: 10rem; */
  /* border-radius: 5rem;
  border: 0.1rem solid;
  width: 20rem;
  height: 20rem; */
  /* justify-content:${(props) => props.info ? css`space-between` : css`center`}; */
  justify-content: center;
  /* flex-wrap: nowrap; */
  width: ${(props) => (props.divide ? css`${props.divide>2?98/3:98/props.divide}%` : props.reduct ? (css`${100-props.reduct}%`): css`100%`) };
  padding: 2rem;
  ${(props) => props.height && css`height: ${props.height}rem;`};
  margin: 1rem 0 0 0;
  cursor: ${(props) => props.notpointer ? css`auto` : css`pointer`};
  border: 1px solid var(--primary);
  border-radius: ${(props) => props.roundborder ? css`3rem` : css`0rem`};
  background-color: ${(props) =>
    props.selected ? css`var(--darkBlue)` : css`var(--softGray)`};
  color: ${(props) =>
    props.selected ? css`var(--secondary)` : css`var(--primary)`};


    @media (max-width: 950px) {
      /* flex-direction:column; */
      width: 80%;
  }

`;

export const ViewGalery = styled.div`
display: flex;
width: 100%;
/* padding: 0 0 0 15rem; */
align-items: center;
justify-content: center;
margin: 0 0 2rem;
/* padding-bottom: 7rem; */

/* height: 40rem; */
`;

export const ViewImages = styled.div`
display: flex;
width: 80rem;
`;

export const Info = styled.div`
  display: flex;
  flex-direction:column;
  align-items:flex-start;
  justify-content:center;
  flex-wrap:nowrap;
  width: 80%;
  margin: 0;
  padding: 1rem;
  border: 0;
  background-color:var(--softGray);
  color:var(--primary);
  p {
    display: flex;
    width: 100%;
    flex-direction:row;
    flex-wrap:nowrap;
    align-items:center;
    justify-content:flex-start;
  }
  title{
    display: flex;
    width: 100%;
    flex-direction:row;
    flex-wrap:nowrap;
    align-items:center;
    justify-content:flex-start;
    font-weight: bold
  }
`;

export const Update = styled.div`
  display: flex;
  flex-direction:column;
  align-items:flex-start;
  justify-content:center;
  flex-wrap:nowrap;
  width: 100%;
  margin: 0 0 0.5rem 1rem;
  padding: 0;
  border: 0;
  background-color:var(--softGray);
  color:var(--gray);
`;

export const Button = styled.div`
  display: flex;
  flex-direction:column;
  align-items:flex-end;
  justify-content:center;
  flex-wrap:nowrap;
  width: 20%;
  margin: 0;
  padding: 1rem;
  border: 0;
  background-color:var(--softGray);
  color:var(--primary);
`;

export const Link = styled.a`
  font-weight: bolder;
  color:var(--darkBlue);
  cursor: pointer;
`;

export const Aviso = styled.div`
  display: flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  flex-wrap:nowrap;
  width: 100%;
  padding: 1rem;
  border: black solid 4px;
  border-radius: 2rem;
  .title {
    font-size: 3rem;
    font-weight: bolder;
  }
  .text {
    font-size: 2rem;
  }
`;